export function fn1(event, res) {
    // json里配置 js:crm.fn1  其中"js:"固定不变，crm为模块名，fn1为方法名
    console.log(this)  // 指向按钮等组件的this，拿到vue的this里的所有东西
    console.log(event) // js:crm.fn1
    console.log(res)   // 前置事件响应值
}

export function fn2(event, res) {
    console.log(this)
    console.log(event)
    console.log(res)
}
